import React from 'react'
import PropTypes from 'prop-types'
import PreventScroll from '../HOC/PreventScroll'
import './index.scss'

const HintComponent = React.memo(props => {
  const { title, content, children, onClickCloseButton } = props
  const { leftBtnText, rightBtnText, leftButton, rightButton } = props

  const { isCenter, useHighLightButtons, useNormalButtons } = props

  return (
    <div className="hint">
      <div className="hint-alert">
        {onClickCloseButton && (
          <span className="hint-close" onClick={onClickCloseButton} />
        )}

        <div className={`hint-top-text ${isCenter ? 'center' : ''}`}>
          {title ? <p>{title}</p> : null}
          {!children ? (
            <span
              className="top-content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          ) : (
            children
          )}
        </div>

        <div className="buttons">
          {leftBtnText ? (
            <div
              className={`hint-button ${
                useHighLightButtons ? 'highlight' : 'left-btn'
              }`}
              onClick={leftButton}
            >
              {leftBtnText}
            </div>
          ) : null}
          <div
            className={`hint-button ${useNormalButtons ? '' : 'highlight'}`}
            onClick={rightButton}
          >
            {rightBtnText}
          </div>
        </div>
      </div>
    </div>
  )
})

HintComponent.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  leftButton: PropTypes.func.isRequired,
  rightButton: PropTypes.func.isRequired,
  leftBtnText: PropTypes.string.isRequired,
  rightBtnText: PropTypes.string.isRequired
}

const Hint = PreventScroll(HintComponent)

export default Hint
